import axios from "axios";
import { ISocialPrompt } from "../Types/account";
import { getUserFromLS } from "../utils/getUserFromLS";

export const updateSocialPrompt = (newSocialPrompt: ISocialPrompt, callback: (response: ISocialPrompt) => void, errorCallback) => {
    const token = getUserFromLS().access_token
    const URL = `${import.meta.env.VITE_API_BASE_URL}/social_prompts/${newSocialPrompt.id}`;

    const requestBody = {};
    if (newSocialPrompt.content_type != null && newSocialPrompt.message != null) {
      requestBody['content_type'] = newSocialPrompt.content_type.replace(/\s/g, '_').toUpperCase()
      requestBody['message'] = newSocialPrompt.message;
    }
    if (newSocialPrompt.subject != null) {
      requestBody['subject'] = newSocialPrompt.subject
    }
    
    return axios(URL, {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: requestBody
    })
      .then((response) => {
        if (callback != null) {
          callback(response.data as ISocialPrompt);
        }
      })
      .catch((error) => {
        // catch error
        if (errorCallback != null) {
          errorCallback(error);
        }
      });
  };